module.exports = __webpack_public_path__ + "static/media/俞家埭快讯.eb6b5b7e.jpg";